const routes = {
  root: '/dashboard',
}

export default routes
